import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { userSlice } from "../redux/user/userSlice";
import { validateToken } from "../redux/asyncThunk/userActions";

const { exitHandle } = userSlice;

const PrivateRoute = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  const { isAuthenticated } = useSelector((state) => state.user.auth);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const checkAuth = async () => {
      if (token) {
        try {
          await dispatch(validateToken()).unwrap();
        } catch (error) {
          dispatch(exitHandle());
        }
      }
      setIsCheckingAuth(false);
    };

    checkAuth();
  }, [dispatch, token]);

  if (isCheckingAuth) {
    return <div>Loading...</div>; // Или ваш лоадер
  }

  return isAuthenticated ? (
    children
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default PrivateRoute;
